import {ReportRow} from '../ReportTypes';
import DuplicateSavedReportMutation from '../../../../mutations/duplicate_saved_report_mutation';
import Util from '../../../shared/util/util';

export const duplicateReport = (report: ReportRow, companyId: string | undefined, successCallback: (result) => void): void => {
	Util.CommitMutation(
		DuplicateSavedReportMutation,
		{
			id: report.id,
			reportService: report.reportService,
			companyId: companyId,
		},
		successCallback
	);
};
